/**
 * <variant-image-circles>
 *
 * Powers the variant-image circles on product cards (collection grids, etc.).
 * Hovering/focusing a circle previews that variant's image in the card; clicking
 * locks it as the selected image. Leaving the circles restores the selected image.
 */
(function () {
  if (window.customElements && customElements.get('variant-image-circles')) return;

  class VariantImageCircles extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-index') || (this.closest('.product-info') || {}).parentElement;
      this.image = this.card ? this.card.querySelector('.reveal img') : null;
      if (!this.image) return;

      this.selectedSrc = this.image.getAttribute('src');
      this.selectedSrcset = this.image.getAttribute('srcset');

      this.circles = Array.prototype.slice.call(this.querySelectorAll('.variant-image-circle'));
      this.circles.forEach((circle) => {
        circle.addEventListener('mouseenter', () => this.swap(circle.dataset.variantImage));
        circle.addEventListener('focus', () => this.swap(circle.dataset.variantImage));
        circle.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(circle);
        });
      });

      this.addEventListener('mouseleave', () => this.restore());
    }

    swap(src) {
      if (!src || !this.image) return;
      this.image.setAttribute('src', src);
      this.image.setAttribute('srcset', src);
    }

    select(circle) {
      this.selectedSrc = circle.dataset.variantImage;
      this.selectedSrcset = circle.dataset.variantImage;
      this.circles.forEach((c) => c.classList.toggle('is-active', c === circle));
      this.swap(this.selectedSrc);
    }

    restore() {
      if (!this.image) return;
      this.image.setAttribute('src', this.selectedSrc);
      this.image.setAttribute('srcset', this.selectedSrcset || this.selectedSrc);
    }
  }

  customElements.define('variant-image-circles', VariantImageCircles);
})();
